import { Injectable } from '@angular/core';
import { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import { 
  faSignOut, 
  faDashboard,
} from '@fortawesome/free-solid-svg-icons';
import {
  faFacebook, 
  faTiktok, 
  faInstagram, 
  faTwitter, 
  faYoutube, 
  faReddit,
  faHackerNews
} from '@fortawesome/free-brands-svg-icons';

@Injectable({
  providedIn: 'root'
})
export class NavIconService {
    private iconMap: { [key: string]: IconDefinition } = {
        // Solid icons
        'faSignOut': faSignOut,
        'faDashboard': faDashboard,
        'faFacebook': faFacebook,
        'faTiktok': faTiktok,
        'faInstagram': faInstagram,
        'faTwitter': faTwitter,
        'faYoutube': faYoutube,
        'faReddit': faReddit,
        'faNewspaper': faHackerNews
      };
    
      constructor() { }
    
      /**
       * Gets the FontAwesome icon definition from a string name
       * @param iconName The name of the icon (e.g., 'faDashboard')
       * @param defaultIcon Optional default icon to return if the requested icon is not found
       * @returns The FontAwesome icon definition
       */
      getIcon(iconName: string, defaultIcon: IconDefinition = faDashboard): IconDefinition {
        return this.iconMap[iconName] || defaultIcon;
      }
    
      /**
       * Checks if an icon exists in the mapping
       * @param iconName The name of the icon to check
       * @returns Boolean indicating if the icon exists
       */
      hasIcon(iconName: string): boolean {
        return !!this.iconMap[iconName];
      }
    
      /**
       * Adds a new icon to the mapping (for runtime extensions)
       * @param iconName The name to use for the icon
       * @param icon The FontAwesome icon definition
       */
      addIcon(iconName: string, icon: IconDefinition): void {
        if (!this.hasIcon(iconName)) {
          this.iconMap[iconName] = icon;
        }
      }
    
      /**
       * Gets all available icon names
       * @returns Array of icon names
       */
      getAvailableIcons(): string[] {
        return Object.keys(this.iconMap);
      }
    }